import EmptyState from '../../../newComponents/emptystate'
import DateHelper from '../../../utils/DateHelper'

const RentRollStatementTable = ({ statementData, isPrint }) => {
 
    return (
        <>
            <div className={isPrint ? "" : "statement-body-scroll-wrapper"}>
                <table className={`table table-hover statement_table p-4 ${isPrint ? "statement_table_pdf" : ""}`}>
                <colgroup>
                    <col style={{ width: '30%' }} />
                    <col style={{ width: '20%' }} />
                    <col style={{ width: '15%' }} />
                    <col style={{ width: '15%' }} />
                    <col style={{ width: '20%' }} />
                </colgroup>
                <thead className={isPrint ? "statement_table_header_pdf" : "statement_table_header"}>
                    <tr>
                        <th className='heading grey_subtext1' scope="col">Tenant Details</th>
                        <th className='heading grey_subtext1' scope="col">Beds/Baths/sqft</th>
                        <th className='heading grey_subtext1' scope="col">Lease Start</th>
                        <th className='heading grey_subtext1' scope="col">Lease End</th>
                        <th className='heading grey_subtext1' scope="col">Rent</th>
                    </tr>
                </thead>
                <tbody className={isPrint ? "statement_table_header_pdf" : "statementbody"}>
                    {statementData && statementData?.rentRollItems?.length > 0 ? (
                        <>
                            {statementData.rentRollItems && statementData?.rentRollItems?.map((elem, index) => (
                                <tr key={index}>
                                    <td className='normal_text grey_subtext1'>
                                        <p className='fw-bold'>{elem.tenantName}</p>
                                        <p>{elem.unitAddress}</p>
                                    </td>
                                    <td className='normal_text grey_subtext1'>
                                        {elem.numberOfBedrooms} / {elem.numberOfBathrooms} / {elem.size}
                                    </td>
                                    <td className='normal_text grey_subtext1'>
                                        {elem.leaseStartDate ? DateHelper.convertUTCtoDateTimeSimple(elem.leaseStartDate) : 'N/A'}
                                    </td>
                                    <td className='normal_text grey_subtext1'>
                                        {elem.leaseEndDate ? DateHelper.convertUTCtoDateTimeSimple(elem.leaseEndDate) : 'N/A'}
                                    </td>
                                    <td className='normal_text grey_subtext1'>
                                        {elem.rent ? `$${elem.rent.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : 'N/A'}
                                    </td>
                                </tr>
                            ))}
                        </>
                    ) : (
                        <tr className='emptyDataRow'>
                            <td colSpan={5}>
                                <EmptyState heading={"No Data Found"} isButton={false} isBorder={false} />
                            </td>
                        </tr>
                    )}
                </tbody>
                </table>
            </div>
        </>
    )
}

export default RentRollStatementTable